import { useCallback, useMemo, useState } from 'react';
import useInterval from './useInterval';

const maxTimesOnEnd = 3;

function useThumbnail(lighthouse) {
  const [timesOnEnd, updateTimesOnEnd] = useState(0);
  const thumbnails = {
    desktop: lighthouse?.desktop.audits?.find((o) => o.id === 'screenshot-thumbnails')?.details.items,
    mobile: lighthouse?.mobile.audits?.find((o) => o.id === 'screenshot-thumbnails')?.details.items,
  };
  const finalScreenshots = {
    desktop: lighthouse?.desktop.audits?.find((o) => o.id === 'final-screenshot').details,
    mobile: lighthouse?.mobile.audits?.find((o) => o.id === 'final-screenshot').details,
  };

  const [showClip, updateShowClip] = useState(false);
  const [currentThumbnail, updateCurrentThumbnail] = useState(0);
  const length = useMemo(() => Math.max(
    thumbnails.desktop.length,
    thumbnails.mobile.length,
  ), [thumbnails.desktop, thumbnails.mobile]);

  useInterval(() => {
    if (showClip) {
      const onEnd = currentThumbnail + 1 > length - 1;
      if (!onEnd) {
        updateCurrentThumbnail(currentThumbnail + 1);
      } else if (timesOnEnd < maxTimesOnEnd) {
        updateTimesOnEnd(timesOnEnd + 1);
      } else {
        updateTimesOnEnd(0);
        updateCurrentThumbnail(0);
      }
    }
  }, 500);

  const startShowingClip = useCallback(() => {
    updateShowClip(true);
    updateCurrentThumbnail(0);
  }, []);

  const stopShowingClip = useCallback(() => {
    updateShowClip(false);
    updateCurrentThumbnail(0);
  }, []);

  const obj = {
    showClip,
    start: startShowingClip,
    stop: stopShowingClip,
  };

  if (!showClip) {
    return {
      ...obj,
      ...finalScreenshots,
    };
  }

  const desktopIndex = currentThumbnail > thumbnails.desktop.length - 1
    ? thumbnails.desktop.length - 1 : currentThumbnail;
  const mobileIndex = currentThumbnail > thumbnails.mobile.length - 1
    ? thumbnails.mobile.length - 1 : currentThumbnail;

  return {
    ...obj,
    desktop: {
      data: showClip ? thumbnails.desktop[desktopIndex].data : finalScreenshots.desktop,
      timing: showClip ? thumbnails.desktop[desktopIndex].timing : 0,
    },
    mobile: {
      data: showClip ? thumbnails.mobile[mobileIndex].data : finalScreenshots.mobile,
      timing: showClip ? thumbnails.mobile[mobileIndex].timing : 0,
    },
  };
}

export default useThumbnail;
